"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pathToTagMap = void 0;
exports.pathToTagMap = {
    '/collections/menopause': 'MENO',
    '/pages/libido': 'MENO',
    '/products/menopause-gut-kit': 'MENO',
    '/products/get-your-body-back-bundle': 'MENO',
    '/products/menopause-skin-kit': 'MENO',
    '/products/meno-capsule-bundles': 'MENO',
    '/products/meno-gummy-bundle': 'MENO',
    '/products/revitalizing-sex-collections': 'MENO',
    '/collections/digestion': 'Other',
    '/collections/bloating-relief': 'Other',
    '/collections/metabolism': 'Other',
    '/collections/acne': 'Other',
    '/collections/skin': 'Other',
    '/products/l-theanine-supplement-capsules': 'Other',
    '/products/mushroom-superblend-capsules': 'Other',
    '/collections/shop-all': 'Other',
    '/collections/bundles': 'Other',
    '/collections/shop-subscriptions': 'Other',
    '/products/digestion-bundle': 'Other',
    '/products/2-gogo-gummy-2-moto-capsule': 'Other',
    '/products/gogo-bundles': 'Other',
    '/products/moto-capsule-bundle': 'Other',
    '/products/retro-bundles': 'Other',
    '/collections/ovarian-health': 'Ovarian',
    '/pages/ovarian-hair': 'Ovarian',
    '/pages/ovarian-strength': 'Ovarian',
    '/pages/blood-sugar': 'Ovarian',
    '/products/flo-ovarian-support-capsule-bundle': 'Ovarian',
    '/products/hormone-balance-kits': 'Ovarian',
    '/products/flo-pimple-patch': 'PMS',
    '/collections/pms': 'PMS',
    '/pages/pms-complete': 'PMS',
    '/products/best-skin-capsule-bundle': 'PMS',
    '/products/best-skin-gummy-bundle': 'PMS',
    '/products/feel-lighter-bundle': 'PMS',
    '/products/metabolism-period-bundle': 'PMS',
    '/products/flo-capsule-bundles': 'PMS',
    '/products/flo-bundles': 'PMS',
    '/products/fit-free-kits': 'PMS',
    '/collections/conception': 'PREGGO',
    '/pages/sperm-health': 'PREGGO',
    '/products/preggo-sperm-health-support-capsules': 'PREGGO',
    '/products/preggo-conception-support-capsules': 'PREGGO',
    '/products/preggo-conception-sperm-health-support-capsules': 'PREGGO',
    '/collections/bladder-control': 'Urinary',
    '/collections/urinary-tract': 'Urinary',
    '/collections/vaginal-health': 'Vaginal',
    '/pages/vaginal-digestive-health': 'Vaginal',
    '/products/happy-body-bundles': 'Vaginal',
    '/products/sex-collections': 'Vaginal',
    '/products/vaginal-urinary-health-bundle': 'Vaginal',
    '/products/uro-vaginal-probiotic-capsule-bundle': 'Vaginal',
    '/products/uro-starter-kits': 'Vaginal',
    '/products/get-balanced-bundles': 'Vaginal',
    '/collections/shop-all/best-seller': 'Other',
    '/collections/shop-all/women-40-plus': 'Other',
    '/collections/shop-all/health-essential': 'Other',
    '/': 'Other',
    '/blogs/blog': 'Other',
    '/pages/blog-pcos': 'PCOS',
};
